import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FileService } from 'src/app/services/api/file.service';

export interface ActivityObservacionesDialogData {
  id: string;
  observaciones?: string | null;
}

export interface ActivityObservacionesDialogResult {
  success: boolean;
  observaciones?: string | null;
}

export const ACTIVITY_ITINERARY_TYPE = 'REGULAR';

@Component({
  selector: 'app-dialog-edit-observaciones',
  templateUrl: './dialog-edit-observaciones.component.html',
  styleUrls: ['./dialog-edit-observaciones.component.css']
})
export class DialogEditObservacionesComponent implements OnInit {
  observacionesControl = new FormControl('', [Validators.maxLength(500)]);
  loader = false;
  latestObservaciones: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<
      DialogEditObservacionesComponent,
      ActivityObservacionesDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: ActivityObservacionesDialogData,
    private readonly fileService: FileService,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.latestObservaciones = this.data.observaciones ?? null;
    this.observacionesControl.setValue(this.latestObservaciones ?? '');

    this.fileService
      .getActivityObservation(this.data.id, ACTIVITY_ITINERARY_TYPE)
      .subscribe({
        next: (result) => {
          const observaciones = result?.getActivityObservation?.observaciones;
          this.latestObservaciones = observaciones ?? null;
          this.observacionesControl.setValue(this.latestObservaciones ?? '');
        },
        error: () => {
          this.toastr.error(
            'No se pudieron cargar las observaciones de la actividad.'
          );
        }
      });
  }

  saveObservaciones(): void {
    this.loader = true;
    this.observacionesControl.markAsTouched();

    if (this.observacionesControl.invalid) {
      this.loader = false;
      return;
    }

    const observaciones = this.observacionesControl.value?.trim() || '';

    this.fileService
      .updateObservacionesActivity(
        this.data.id,
        observaciones,
        ACTIVITY_ITINERARY_TYPE
      )
      .subscribe({
        next: () => {
          this.loader = false;
          this.dialogRef.close({
            success: true,
            observaciones
          });
        },
        error: () => {
          this.loader = false;
          this.toastr.error(
            'No se pudo actualizar las observaciones de la actividad.'
          );
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close({
      success: false,
      observaciones: this.latestObservaciones
    });
  }
}
